import {mustache} from "../handlebars_family.ts";
import $ from '../$.js'
import * as FwDatas from "../FwDatas.ts";

// a set of functions to initialize widgets and custom decorations in HTML
type Widget = {
  initDom?:(a:HTMLElement)=>void ,
  destroyDom?:(a:HTMLElement)=>void
}

type Decorator = (nodes: JQuery) => void;
type Cleaner = (nodes: JQuery) => void;

var
  widgetDefinition : {[x: string]: Widget} = {},
  currentSkin :string | undefined,
  decorators: Decorator[] = [function(nodes :JQuery){
    nodes.find("[data-widget]").add(nodes.filter("[data-widget]")).each(function(idx,nodeWithWidget){
      //with amd it was asynchronous, if not some widget does not work well so we redo this like before with a setTimeout
      setTimeout(()=>{
        nodeWithWidget.getAttribute('data-widget').split(/\s/g).forEach(widgetName=>{
          var widget = widgetDefinition[widgetName]
          if(widget && widget.initDom){
            widget.initDom(nodeWithWidget)
          }else{
            console.log("Please ADD \nHtml.registerWidget('"+widgetName+"',{initDom})")
          }
        })
      },1)
    });
  },function(nodes :JQuery){
    //remove animated class because it causes issue with action-menu
    var animatedNodes = nodes.find(".animated").add(nodes.filter(".animated"));
    if(animatedNodes.length){
      setTimeout(function(){
        animatedNodes.each(function(idx,animatedNode){
          animatedNode.classList.remove('animated')
        })
      },1000)
    }
  }],
  cleaners: Cleaner[] = [/*cleaner for widget*/function(nodes: JQuery){
    nodes.find("[data-widget]").add(nodes.filter("[data-widget]")).each(function(idx,nodeWithWidget){

      nodeWithWidget.getAttribute('data-widget').split(/\s/g).forEach(widgetName=>{
        var widget = widgetDefinition[widgetName]
        if(widget && widget.destroyDom){
          widget.destroyDom(nodeWithWidget)
        }else if(!widget){
          console.log("Please ADD \nHtml.registerWidget('"+widgetName+"',{initDom})")
        }
      })

    });
  },/*cleaner for video tag*/
  function(nodes: JQuery){
    //when we clean a video we want it to stop downloading in order to preserve bandwith
    //the equivalent for images does not work
    nodes.find('video').each(function(this:HTMLVideoElement){
      this.pause();
      this.src ="";
      $(this).remove();
    });
  }];

function checkInputTypeSupported(type :string) {
    var input = document.createElement("input");
    input.setAttribute("type", type);
    return input.type == type;
}
if(!checkInputTypeSupported('datetime-local')){
  decorators.push(function(nodes){
    nodes.find("input[type='datetime-local']").each(function(idx,nodeWithWidget){
      const inputElement = nodeWithWidget as HTMLInputElement;
      inputElement.placeholder = "yyyy-mm-ddThh:mm";
      inputElement.pattern = "[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}";
    })
  })
}
/**
 * Initialize widgets and custom decorations in given node
 */
function initHtml(nodes :JQuery|HTMLElement){
  var jqueryNode = $(nodes)
  decorators.forEach(function(decorator){
    decorator(jqueryNode);
  });
  return nodes;
}
function cleanHtml(nodes:JQuery|HTMLElement){
  var jqueryNode = $(nodes)
  cleaners.forEach(function(cleaner){
    cleaner(jqueryNode);
  });
}

/*
Function: setHtml(node,mustacheName,data)
Replace data in template with given name and insert HTML in node

After inserting the HTML, widgets and custom decorations are initialized
using initHtml().

Parameters:
  node - object, jQuery object or HTMLElement wrapping the parent element of the new html
  mustacheName - string, name of the Mustache template
  data - optional, object, data with values to replace in template,
    defaults to {} to replace only localization keys
*/
function setHtml(node:HTMLElement, mustacheName :MUS, data :any){
  cleanHtml($(node).children());
  node.innerHTML = mustache(mustacheName,data);
  initHtml($(node).children());
}

function setHtmlArray(node:HTMLElement, mustacheName :MUS, array :any[]){
  cleanHtml($(node).children());
  node.innerHTML = array.map(data=>mustache(mustacheName,data)).join('');
  initHtml($(node).children());
}

function replaceWithDom(
  elements: HTMLElement[],
  mustacheName: MUS,
  data: any
): HTMLElement[] {

  if (elements.length === 0) return [];

  // Nettoyage comme cleanHtml (si tu veux l'appeler ici)
  elements.forEach(cleanHtml);

  // On rend le mustache une seule fois
  const html = mustache(mustacheName, data);
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  const replaced = Array.from(template.content.children) as HTMLElement[];

  // Remplacement : on ne garde que le premier, on supprime les autres
  elements.forEach((el, idx) => {
    if (idx !== 0) {
      el.remove();
    } else {
      el.replaceWith(...replaced);
    }
  });

  // Initialisation (comme initHtml)
  replaced.forEach(initHtml);

  return replaced;
}
function replaceWithSingleDom(
  element: HTMLElement,
  mustacheName: MUS,
  data: any
): HTMLElement {
  var replaced = replaceWithDom([element],mustacheName,data)
  if (replaced.length !== 1) {
    console.log(replaced)
    throw new Error("cannot replace simple element by multiple this way");
  }
  return replaced[0];
}


function enableComments(el:HTMLElement){
  el.childNodes.forEach(function(node){
    if(node.nodeType === 8){
      $(node).replaceWith((node as Comment).data);
    }
  });
  initHtml($(el));
  return true;
}


/*
Function: setHtmlAtStart(node,mustacheName,data)
Replace data in template with given name and prepend HTML at start of node

After inserting the HTML, widgets and custom decorations are initialized
using initHtml().

Parameters:
  node - object, jQuery object wrapping the parent element of the new html
  mustacheName - string, name of the Mustache template
  data - optional, object, data with values to replace in template,
    defaults to {} to replace only localization keys
*/
function setHtmlAtStart(node:HTMLElement, mustacheName :MUS, data :any): HTMLElement[] {
  const html = mustache(mustacheName, data);
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  const replaced = Array.from(template.content.children) as HTMLElement[];
  node.prepend(...replaced)
  replaced.forEach(initHtml)
  return replaced;
}

/*
Function: setHtmlAtEnd(node,mustacheName,data)
Replace data in template with given name and append HTML at end of node

After inserting the HTML, widgets and custom decorations are initialized
using initHtml().

Parameters:
  node - object, jQuery object wrapping the parent element of the new html
  mustacheName - string, name of the Mustache template
  data - optional, object, data with values to replace in template,
    defaults to {} to replace only localization keys
*/
function setHtmlAtEnd(node:HTMLElement, mustacheName :MUS, data :any): HTMLElement[] {
  const html = mustache(mustacheName, data);
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  const replaced = Array.from(template.content.children) as HTMLElement[];
  node.append(...replaced)
  replaced.forEach(initHtml)
  return replaced;
}

/**
 * DOM-native version of setHtmlAtEnd - returns HTMLElement instead of jQuery
 */
export function setHtmlAtEndDom(node: HTMLElement, mustacheName: MUS, data: any): HTMLElement {
  const html = mustache(mustacheName, data);
  const template = document.createElement("template");
  template.innerHTML = html.trim();

  // Append at end
  const fragment = template.content;
  const newElements = Array.from(fragment.children) as HTMLElement[];
  node.append(...newElements);

  // Initialize only the new elements
  newElements.forEach(initHtml);

  // Return first new element (for compatibility with jQuery version)
  return newElements[0];
}

var
 actionsDom :Record<string, (this: HTMLElement, ...args: string[]) => any> = {},
 runningClick: boolean = false,
 runningClickTimeout: ReturnType<typeof setTimeout> | undefined;

function isRunningClick(){
  return runningClick;
}
function runClick(){
  runningClick = true;
  clearTimeout(runningClickTimeout);
  runningClickTimeout = setTimeout(function(){runningClick=false},50)
}

export function createDelegateListener(selector:string,listener :(event:Event,target:HTMLElement)=>Promise<boolean|void>|boolean|void): (event: Event) => void {
  return function(event :Event){
    let crawler = event.target as HTMLElement | null;
    while(crawler!==null){
      if(crawler.matches(selector)){
        if(listener(event,crawler)!==true){
          return;
        }
      }
      crawler = crawler.parentElement;
    }
  }
}
document.addEventListener("click",createDelegateListener("[data-fw-onclick]",function(event,target){
  event.preventDefault();
  const onclick = target.getAttribute("data-fw-onclick");
  if(!onclick) return;

  const params = onclick.split('|');
  const rawActionName = params[0];
  const actionName = FwDatas.getPermission(rawActionName);

  // Execute native HTMLElement handlers
  const actionDom = actionsDom[actionName];
  if(actionDom){
    runClick();
    return actionDom.apply(target, params.slice(1))
  }else{
    throw new Error("no action for "+onclick+" ("+rawActionName+" => "+actionName+" )");
  }
}))


function trigger(node :JQuery|HTMLElement|null,rawActionName?:string,params?:string[]): void {
  const actionName = FwDatas.getPermission(rawActionName);

  // Execute native HTMLElement handlers
  const actionDom = actionsDom[actionName];
  if(actionDom){
    const element = node instanceof HTMLElement ? node : (node as JQuery)?.get(0);
    return actionDom.apply(element, params);
    
  }else{
    throw new Error("no action for "+rawActionName+" ("+rawActionName+" => "+actionName+" )");
  }
}

function triggerbystring(node :JQuery|HTMLElement|null,str :string): void {
  const params = str.split('|');
  const rawActionName = params[0];

  trigger(node,rawActionName,params.slice(1));
}

function registerDom(obj: namedOnclick){
  Object.entries(obj).forEach(([key, fn])=>{
    if(actionsDom[key]){
      throw new Error("cannot define the same action twice in registerDom: "+key);
    }
    actionsDom[key] = fn;
  });
}
export function registerWidget(key :string,obj :Widget){
  if(widgetDefinition[key]){
    console.log(new Error("cannot define the same widget twice : "+key));
  }else{
    widgetDefinition[key] = obj;
  }
}

function wait(clause : ()=>boolean){
  return new Promise<void>((resolve,reject)=>{
    const interval = setInterval(function(){
      if(clause()){
        clearInterval(interval);
        resolve();
      }
    },50)
  })

}

function changeSkin(title: string | undefined | null): boolean {
  // a.getAttribute will return null and not undefined so to avoid to use != but !== we change requested title
  if(title===undefined){
    title=null;
  }
  if(title===currentSkin){
    return false;
  }else{
    currentSkin = title;
  }

  return true;
}
const escaperNode = document.createElement('div');
function escape(unsafeString :string){
  escaperNode.innerText = unsafeString;
  return escaperNode.innerHTML;
}

export function getDomMetaId(node : Element) :string|undefined{
  var metaIdFound = node.getAttribute('data-fw-meta-id');
  if(metaIdFound!==null) return metaIdFound;
  if(node.parentElement) return getDomMetaId(node.parentElement)
}
export function getDomMetaIdNode(node : HTMLElement):HTMLElement|undefined{
  var metaId = node.getAttribute('data-fw-meta-id');
  if(metaId!==null) return node;
  if(node.parentElement) return getDomMetaIdNode(node.parentElement)
}

function getStackLine(){
  return new Error().stack?.split(/\r?\n|\r/g)[3].trim()
}
Object.assign(HTMLElement.prototype,{
  attr(this : HTMLElement, name :string){
    console.log(`Use of .attr("${name}") on HTMLElement, replace with .getAttribute("${name}") on ${getStackLine()}`)
    return this.getAttribute(name);
  },
  parent(this : HTMLElement){
    console.log(`Use of .parent() on HTMLElement, replace with .parentElement on ${getStackLine()}`)
    return this.parentElement;
  },
  parents(this : HTMLElement, selector:string){
    console.log('use HTMLElement.closest() instead '+getStackLine())
    return this.closest(selector)
  }
});

(window as any).Html =  {
  escape,
  cleanHtml,
  replaceWithDom,
  enableComments,
  setHtmlAtStart,
  setHtmlAtEnd,
  setHtml,
  mustache,

  isRunningClick,
  runClick,
  registerDom,
  trigger,
  triggerbystring,
  registerWidget,
  changeSkin,
  wait,
  fadeIn,
  fadeOut
};

// Helper functions for DOM animations without jQuery
export function fadeIn(element: HTMLElement, duration: number = 400): Promise<void> {
  element.style.display = 'block';
  element.style.opacity = '0';
  element.style.transition = `opacity ${duration}ms`;

  // Force reflow to ensure the initial state is applied
  element.offsetHeight;

  element.style.opacity = '1';
  return new Promise((resolve,reject)=>{
    setTimeout(resolve, duration)
  })
}

export function fadeOut(element: HTMLElement, duration: number = 400): Promise<void> {
  element.style.opacity = '1';
  element.style.transition = `opacity ${duration}ms`;
  element.style.opacity = '0';
  console.log("fadeOut")
  return new Promise((resolve,reject)=>{
    setTimeout(()=>{
      element.style.display = 'none';
      resolve()
    }, duration)
  });
}

export {
  escape,
  cleanHtml,
  replaceWithDom,
  replaceWithSingleDom,

  enableComments,
  setHtmlAtStart,
  setHtmlAtEnd,
  setHtml,
  setHtmlArray,
  mustache,

  isRunningClick,
  runClick,
  registerDom,
  trigger,
  triggerbystring,
  changeSkin,
  wait
}